import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import axios from "axios";
import "./Service.css";
import InnerBanner from "../components/InnerBanner";
import { triggerBookingPopup } from "../components/Header";

const fallbackServices = [
  {
    _id: "washing",
    title: "Washing Machine Repair Service",
    types: ["Front Load", "Top Load", "Semi Automatic"],
    issues: ["Not spinning", "Water leakage", "Drum issues", "Power failure"],
  },
  {
    _id: "fridge",
    title: "Refrigerator Repair Service",
    types: ["Single Door", "Double Door", "Side-by-Side", "Mini Fridge"],
    issues: [
      "Cooling issues",
      "Gas refilling",
      "Compressor problems",
      "Noise issues",
    ],
  },
  {
    _id: "ac",
    title: "AC Repair Service",
    types: ["Split AC", "Window AC", "Inverter AC", "Smart AC"],
    issues: ["Not cooling", "Gas leakage", "Compressor failure", "Water leakage"],
  },
];

export default function ServicesPage() {
  const [services, setServices] = useState(fallbackServices);
  const [loading, setLoading] = useState(true);

  const typeRoutes = {
    washing: {
      "Front Load": "/lg-front-load-washing-machine-service-bangalore",
      "Top Load": "/lg-top-load-washing-machine-service-bangalore",
      "Semi Automatic": "/lg-washing-machine-service-bangalore",
    },
  };

  const issueRoutes = {
    washing: {
      "Not spinning": "/lg-washing-machine-not-spinning",
      "Water leakage": "/lg-washing-machine-water-leak-repair",
      "Drum issues": "/lg-washing-machine-drum-repair",
      "Power failure": "/lg-washing-machine-no-power-issue",
    },
  };

  const getServiceKey = (service) => {
    const rawValue = `${service?._id || ""} ${service?.title || ""}`.toLowerCase();

    if (rawValue.includes("washing")) {
      return "washing";
    }

    if (rawValue.includes("fridge") || rawValue.includes("refrigerator")) {
      return "fridge";
    }

    if (rawValue.includes("ac") || rawValue.includes("air conditioner")) {
      return "ac";
    }

    return service?._id;
  };

  useEffect(() => {
    axios
      .get("https://api.customersupports24x7.in/api/services")
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setServices(res.data);
        } else {
          setServices(fallbackServices);
        }
      })
      .catch((err) => {
        console.log("Failed to load services, using fallback:", err);
        setServices(fallbackServices);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <Helmet>
        <title>Appliance Repair Services Bangalore | All Brands Support</title>
        <meta
          name="description"
          content="Reliable appliance repair services in Bangalore for washing machines, refrigerators, ACs, microwaves, and more."
        />
        <meta
          name="keywords"
          content="appliance services bangalore, appliance repair services in Bangalore"
        />
        <meta
          property="og:title"
          content="Appliance Repair Services Bangalore | All Brands Support"
        />
        <meta
          property="og:description"
          content="Reliable appliance repair services in Bangalore for washing machines, refrigerators, ACs, microwaves, and more."
        />
        <meta
          property="og:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <meta property="og:url" content="https://customersupports24x7.in/services" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Appliance Repair Services Bangalore | All Brands Support"
        />
        <meta
          name="twitter:description"
          content="Reliable appliance repair services in Bangalore for washing machines, refrigerators, ACs, microwaves, and more."
        />
        <meta
          name="twitter:image"
          content="https://customersupports24x7.in/customerSupport.png"
        />
        <link rel="canonical" href="https://customersupports24x7.in/services" />
      </Helmet>

      <div className="perfect-service-wrapper">
        <div className="abstract-bg-glow"></div>

        <InnerBanner title="Our Services" />

        {loading ? (
          <div className="services-loading">
            <p>Loading our services, please wait...</p>
          </div>
        ) : services.length === 0 ? (
          <div className="services-loading">
            <p>No services found right now. Please try again later.</p>
          </div>
        ) : (
          <div className="services-bento-grid">
            {services.map((service) => (
              <div key={service._id} className="bento-card">
                {(() => {
                  const serviceKey = getServiceKey(service);

                  return (
                    <>
                <div className="card-header">
                  <div className="icon-box">🔧</div>
                  <h2>{service.title}</h2>
                </div>

                <div className="service-types">
                  {service.types?.map((type, index) =>
                    typeRoutes[serviceKey]?.[type] ? (
                      <Link
                        key={index}
                        to={typeRoutes[serviceKey][type]}
                        className="service-type-link"
                      >
                        {type}
                      </Link>
                    ) : (
                      <span key={index}>{type}</span>
                    )
                  )}
                </div>

                <div className="issue-tags">
                  <h4>Common Issues</h4>
                  <ul>
                    {service.issues?.map((issue, index) => (
                      <li key={index}>
                        {issueRoutes[serviceKey]?.[issue] ? (
                          <Link
                            to={issueRoutes[serviceKey][issue]}
                            className="issue-link"
                          >
                            ✓ {issue}
                          </Link>
                        ) : (
                          <>✓ {issue}</>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>

                <button onClick={triggerBookingPopup} className="service-link">
                  Book Repair →
                </button>
                    </>
                  );
                })()}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
}
